export function ethernetTitle(online, connected) {
    if (!online) {
        return `Нет связи с устройством`;
    }
    if (connected && online) {
        return 'Подключен';
    }
    return 'Нет соединения';
}
